export interface DestinationBankAccount {
  id: string;
  label: string;
  bankNumber: string;
  branchNumber: string;
  accountNumber: string;
}

export const DESTINATION_BANK_ACCOUNTS: DestinationBankAccount[] = [
  { id: 'pagi-52-185-701831', label: "בנק פאג\"י (52) - סניף 185 - חשבון 701831", bankNumber: '52', branchNumber: '185', accountNumber: '701831' },
  { id: 'mercantile-17-734-78426938', label: 'בנק מרכנתיל (17) - סניף 734 - חשבון 78426938', bankNumber: '17', branchNumber: '734', accountNumber: '78426938' },
];

export function findDestinationBank(bankNumber?: string, branchNumber?: string, accountNumber?: string): DestinationBankAccount | undefined {
  if (!bankNumber || !branchNumber || !accountNumber) return undefined;
  return DESTINATION_BANK_ACCOUNTS.find(
    (a) => a.bankNumber === bankNumber && a.branchNumber === branchNumber && a.accountNumber === accountNumber,
  );
}
